// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Box, Flex } from '../grid';
import { breakpointsToArray } from '../../helpers';
import {
  getMake,
  getModel,
  getFueltype,
  getDefaultImageUrl,
} from '../../store/pdb/selectors';
import {
  getCartGroups,
  getCartPrice,
  getCartBasePrice,
  getActiveColor,
  getDeliverytime,
  getPowerFromActivePackage,
  getEngineFromActivePackage,
} from '../../store/configuration';
import {
  Container,
  Footer,
  Header,
  Image,
  ImageContainer,
  Model,
  ProductGroup,
  SaveButton,
} from './atoms';
import Tags from '../tags';
import { getIsVbmrEnabled } from '../../store/configuration/vbmr/selectors';
import { getLabel } from '../../store/vbmr/selectors';
import type { StateProps, OwnProps } from './types';
import withErrorBoundary from '../withErrorBoundary';

type Props = {|
  ...StateProps,
  ...OwnProps,
|};

const Cart = ({
  basePrice,
  boxed = false,
  className,
  color,
  defaultImage,
  delivery,
  displayActions,
  engine,
  fueltype,
  groups,
  make,
  model,
  onSave,
  power,
  showSave,
  showVbmrTag,
  totalPrice,
  vbmrText,
}: Props) => (
  <Container boxed={boxed} className={className}>
    <Box
      width={breakpointsToArray({ default: 1, md: boxed ? 1 / 2 : 1, lg: 1 })}
      pr={breakpointsToArray({ default: 0, md: boxed ? '1rem' : 0, lg: 0 })}
      flexShrink="0"
    >
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Header
          make={make}
          model={model}
          engine={engine}
          power={power}
          fueltype={fueltype}
        />
        {showSave && onSave && <SaveButton onClick={onSave} />}
      </Flex>
      <ImageContainer>
        <Image
          alt={`${make} ${model}`}
          url={(color && color.image && color.image.url) || defaultImage}
        />
        {showVbmrTag && <Tags large tags={[vbmrText]} />}
      </ImageContainer>
    </Box>
    <Box width={breakpointsToArray({ default: 1, md: boxed ? 1 / 2 : 1, lg: 1 })}>
      <Model price={Number(basePrice)} delivery={!showVbmrTag && delivery} boxed={boxed} />
      {groups && groups.filter(group => group.items.length > 0).map((group, index) => (
        <ProductGroup
          key={`cart-${index}`}  // eslint-disable-line
          index={`cart-${index}`}
          id={group.id}
          {...group}
        />
      ))}
      <Footer price={totalPrice} displayActions={displayActions} />
    </Box>
  </Container>
);

Cart.defaultProps = {
  displayActions: true,
  boxed: false,
  groups: [],
  onSave: null,
  showSave: false,
};

const mapStateToProps = (state): StateProps => ({
  make: getMake(state),
  model: getModel(state),
  engine: getEngineFromActivePackage(state),
  power: getPowerFromActivePackage(state),
  fueltype: getFueltype(state),
  defaultImage: getDefaultImageUrl(state),
  groups: getCartGroups(state),
  basePrice: getCartBasePrice(state),
  totalPrice: getCartPrice(state),
  color: getActiveColor(state),
  delivery: getDeliverytime(state),
  vbmrText: getLabel(state),
  showVbmrTag: getIsVbmrEnabled(state),
});

export default withErrorBoundary<any, any, OwnProps, any, any>(
  connect<any, OwnProps, StateProps, any, any, any>(
    mapStateToProps,
  )(Cart),
);
